import { render, staticRenderFns } from "./serviceGroup.vue?vue&type=template&id=1de1160e&scoped=true&"
import script from "./serviceGroup.vue?vue&type=script&lang=js&"
export * from "./serviceGroup.vue?vue&type=script&lang=js&"
import style0 from "./serviceGroup.vue?vue&type=style&index=0&id=1de1160e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1de1160e",
  null
  
)

export default component.exports